<template>
    <input :id="name" type="text">
</template>

<script>

    export default {
        props: {
            min: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: true
            },
            value: {
                required: true
            },
            ticks: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            ticksLabels: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            name: {
                type: String,
                required: true
            },
            step : {
                type : Number,
                required : false,
                default : 1
            },
            orientation : {
                type : String,
                required : false,
                default: 'horizontal'
            },
            tooltip : {
                type : Boolean,
                required : false,
                default : true
            },
            reversed : {
                type : Boolean,
                required: false,
                default: false
            },
            changeEvent : {
                type : Function,
                required : false,
            }
        },
        mounted() {
            var vm = this;

            this.$nextTick(function () {
                var sliderElement = $("#" + vm.name);

                var options = {
                    value  : vm.value,
                    ticks: vm.ticks,
                    ticks_labels: vm.ticksLabels,
                    min: vm.min,
                    max: vm.max,
                    step: vm.step,
                    orientation: vm.orientation,
                    tooltip: vm.tooltip ? "show" : 'hide',
                    reversed: vm.reversed
                };

                vm.slider = sliderElement.slider(options);

                vm.slider.on("change", function (event) {
                    vm.changeEvent(event.value)
                });
            });
        },
        onDestroy() {
            this.slider.destroy()
        },
        data() {
            return {
                slider: null
            }
        }
    };
</script>